export const ROLES = {
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  MERCHANT_ADMIN: 'MERCHANT_ADMIN',
  MERCHANT_EDITOR: 'MERCHANT_EDITOR',
  AGENCY_ADMIN: 'AGENCY_ADMIN',
  AGENCY_EDITOR: 'AGENCY_EDITOR',
  AGENCY_CAMPAIGN_MANAGER: 'AGENCY_CAMPAIGN_MANAGER',
  CONSUMER: 'CONSUMER',
}

export const ROLE_LABELS = {
  [ROLES.PLATFORM_ADMIN]: 'Platform Admin',
  [ROLES.MERCHANT_ADMIN]: 'Merchant Admin',
  [ROLES.MERCHANT_EDITOR]: 'Merchant Editor',
  [ROLES.AGENCY_ADMIN]: 'Agency Admin',
  [ROLES.AGENCY_EDITOR]: 'Agency Editor',
  [ROLES.AGENCY_CAMPAIGN_MANAGER]: 'Agency Campaign Manager',
  [ROLES.CONSUMER]: 'Consumer',
}

export const ROLE_LIST = Object.values(ROLES)

export const ROLE_OPTIONS = ROLE_LIST.map((value) => ({
  value,
  label: ROLE_LABELS[value] || value,
}))

export default ROLES
